// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__N0xaW","label":"LabeledBox_label__2UxsU"};